import { buildRoutingIterations, routeDevices } from "./routeDevices.logic";
export function autoPipeRouting(args) {
    return routeDevices(args);
}
export function buildAutoPipeRoutingIterations(args) {
    console.log("Building routing iterations with args:", args);
    return buildRoutingIterations(args);
}
